module.exports = __webpack_public_path__ + "img/logo_cbf4d.png";